<template>
  <q-input
    ref="inputRef"
    type="textarea"
    class="widget-field-textarea"
    :class="{
      'widget-field-textarea--error': hasError,
      'widget-field-textarea--no-border': noBorder,
    }"
    :style="{
      '--widget-field-textarea-size': size,
    }"
    :autogrow="autogrow"
    :maxlength="maxLength"
    :model-value="modelValue"
    :placeholder="placeholder"
    :error-state="hasError"
    :bottom-slots="hasError"
    :readonly="readonly"
    @update:model-value="$emit('update:model-value', String($event || ''))"
    @blur="$emit('blur')"
  >
    <template v-slot:hint>
      <widget-field-error :text="errorMessage" />
    </template>
  </q-input>
</template>

<script lang="ts">
import { widgetFieldEvents, widgetFieldProps } from '@widgets/shared/components/fields/types'
import WidgetFieldError from '@widgets/shared/components/fields/WidgetFieldError.vue'
import { defineComponent, onMounted, ref, watch } from '@/composition/vue/compositionApi'

export const widgetFieldTextareaProps = {
  placeholder: {
    type: String,
  },
  size: {
    type: String,
    default: '80px',
  },
  autogrow: {
    type: Boolean,
    default: false,
  },
  maxLength: {
    type: Number,
  },
  noBorder: {
    type: Boolean,
    default: false,
  },
  autofocus: {
    type: Boolean,
  },
}

export default defineComponent({
  components: { WidgetFieldError },
  props: {
    ...widgetFieldProps,
    ...widgetFieldTextareaProps,
  },
  emits: widgetFieldEvents,
  setup(props) {
    const inputRef = ref()

    const focus = () => {
      if (props.readonly) return
      inputRef.value?.focus()
    }

    watch(
      () => props.autofocus,
      (value) => {
        if (value) {
          focus()
        }
      },
    )

    onMounted(() => {
      if (props.autofocus) {
        focus()
      }
    })

    return {
      inputRef,
      focus,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
@import '@/styles/quasar-field.scss';

.widget-field-textarea {
  @include quasar-field-default;

  &--error {
    @include quasar-field-error;
  }

  // default style
  :deep(.q-field__control) {
    min-height: 80px;
    padding: 0 !important;
    textarea {
      @include thumb-without-track;
      resize: none;
      line-height: 1.5;
      padding: 5px 10px;
      margin: 3px 4px 6px 3px;
    }
  }

  &--no-border {
    :deep(.q-field__control::before) {
      border: none !important;
      box-shadow: none !important;
    }
  }

  &:deep(.q-field__control) {
    // Don't use v-bind because it is not working here, I don't know why
    height: calc(var(--widget-field-textarea-size));
  }
}
</style>
